module.exports = __webpack_public_path__ + "media/dashboard/assets/images/monitor-share-19145d9b33b4528123691e0aa83b9ccd.svg";